<nav class="navbar navbar navbar-expand-md navbar-dark">
  <div class="navbar-header">
      
      
      <div class="navbar-brand" (click)="openDashboard()">
          
          <!-- <span class="header-tr-logo" title="Talent Readiness"><img src="assets/talentReadiness-logo.png" alt="Talent Readiness"></span> -->
          <span class="header-niit-logo" title="NIIT"><img src="assets/logo.svg" alt="NIIT"></span>
          <span class="tr-logo"><span class="tr">TR</span><span class="talent">Talent</span><span class="readiness">Readiness</span></span>
          <!-- <span class="tr-logo" title="SquadHub"><span class="talent">Talent</span><span class="readiness">Readiness</span></span> -->
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
          </ul>
          <ul class="navbar-nav">
                <li class="nav-item" *ngIf="showNominateButton">
                    <div class="image-add-work dash-border" >
                        <a  class="nav-link"  title="Nominate">
                            <img src="assets/Nominee.png" (click)=onNomiClick()>
                            <!-- <i class="fa fa-bullseye" (click)=onNomiClick()></i> -->
                            <span #spn1 class="dashboard-top-nav-text" (click)=onNomiClick()>
                                    Nominate
                            </span>
                        </a>
                    </div>
                </li>
                <li class="nav-item">
                    <!-- <a href="assets/Talent_Readiness_User_Guide_v0.1.pdf" title="Help" class="HelpIconButton" target="_blank">
                        <i class="svg-helpdesk-icon"></i>
                        <img src="assets/helpIcon.png" class="helpIcon" />
                    </a> -->
                    <div class="image-add-work dash-border">
                        <a href="assets/Talent_Readiness_User_Guide_v0.1.pdf" target="_blank" class="nav-link" title="User Guide">
                            <!-- <i class="svg-helpdesk-icon"></i> -->
                            <img src="assets/user-guide.png">
                            <!-- <i class="fa fa-question-circle"></i> -->
                            <span class="dashboard-top-nav-text">User Guide</span>
                        </a>
                    </div>
                </li>
                <li class="nav-item">
                    <div class="image-add-work dash-border">
                        <a class="nav-link" title="{{ loginUserName }}" style="min-width: 80px;">
                            <img src="assets/User.png">
                            <!-- <i class="fa fa-user"></i> -->
                            <span class="dashboard-top-nav-text">
                                    {{loginUserName}}
                            </span>
                        </a>
                    </div>
                </li>
                <li class="nav-item">
                    <div class="image-add-work dash-border">
                        <a class="nav-link" (click)="logout()" title="Sign Out">
                            <img src="assets/Logout-Icons.png">
                            <!-- <i class="fa fa-sign-out-alt"></i> -->
                            <span #spn2 class="dashboard-top-nav-text">
                                    Sign Out
                            </span>
                        </a>
                    </div>
                </li>
              <!-- <li class="nav-item">
                  <div title="User" class="header-user-details">
                      {{loginUserName}}<br />
                      {{userType}}
                  </div>
              </li> -->
              <!-- <li class="nav-item">
                  <a _ngcontent-c2="" title="User Profile" class="ff1" id="dropdownMenuProfileButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-user profileIcon"></i>
                      <span class="caret"></span>
                  </a>
                  <div class="dropdown-menu" id="dropDownPro" aria-labelledby="dropdownMenuProfileButton">
                      <a class="dropdown-item cursorLink">Signed in as
                          <br />
                          <span>{{loginUserName}}</span>
                          <br>
                          {{userType}}
                      </a>
                      <hr />
                      <a class="dropdown-item" (click)="logout()">Sign out</a>
                  </div>
              </li> -->
          </ul>
      </div>
      <div class="loader" *ngIf="loading"></div>
  </div>
</nav>
